import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useFormik } from "formik";
import Select from "react-select";
import qs from "qs";
import {
	useGetFranchiseStores,
	useGetTaxMasterRestaurant,
	useUpdateTaxMasterAddress,
} from "../../../../queryHooks";
import { useStore } from "../../../../zustand/store";
import CS from "../../../../services/commonService";
import { masterAddressSchema } from "../../../../validations";

const TaxSettings = () => {
	const setLoading = useStore((state) => state.setLoading);
	const { slug } = useParams();

	const [childRestaurantOptions, setChildRestaurantOptions] = useState([]);

	const { data: storesApiData } = useGetFranchiseStores({
		restaurantId: slug,
		params: qs.stringify({
			pagination: false,
			include_parent_restaurant: true,
		}),
	});

	useEffect(() => {
		if (storesApiData?.status === "success") {
			let _restaurants = [];
			storesApiData?.data?.records?.forEach((element) => {
				_restaurants.push({
					label: getAddressLabel(element),
					value: element.id,
				});
			});
			setChildRestaurantOptions(_restaurants);
		}
	}, [storesApiData]);

	const getAddressLabel = (element) => {
		return `${element?.name} - ${element?.address_street_1}, ${
			element?.address_street_2 ? element?.address_street_2 + "," : ""
		} ${element?.address_state}, ${element?.address_city}, ${
			element?.address_country
		}, ${element?.address_postal_code}`;
	};

	const {
		mutateAsync: updateTaxMasterAsync,
		data: updateTaxMasterData,
		error: updateTaxMasterError,
		isLoading: updateTaxMasterLoading,
	} = useUpdateTaxMasterAddress();

	useEffect(() => {
		if (updateTaxMasterData?.status === "success") {
			CS.showSuccessMessage(updateTaxMasterData?.message);
		}
	}, [updateTaxMasterData]);

	useEffect(() => {
		if (updateTaxMasterError) {
			CS.showErrorMessage(
				`${
					updateTaxMasterError?.response?.data?.message ||
					updateTaxMasterError?.data?.message ||
					updateTaxMasterError?.message
				}`
			);
		}
	}, [updateTaxMasterError]);

	const { values, errors, touched, handleChange, handleSubmit } = useFormik({
		initialValues: {
			restaurant: "",
		},
		enableReinitialize: true,
		validationSchema: masterAddressSchema,
		onSubmit: (value) => {
			updateTaxMasterAsync({
				restaurantId: slug,
				body: {
					taxable_restaurant_id: value.restaurant?.value,
				},
			});
		},
	});

	const { data: masterApiData } = useGetTaxMasterRestaurant(slug);

	useEffect(() => {
		if (masterApiData?.status === "success") {
			let val = {
				label: getAddressLabel(masterApiData?.data?.taxable_restaurant),
				value: masterApiData?.data?.taxable_restaurant?.restaurant_id,
			};
			let event = {
				target: { name: "restaurant", value: val },
			};
			handleChange(event);
		}
	}, [masterApiData]);

	useEffect(() => {
		setLoading(updateTaxMasterLoading);
	}, [updateTaxMasterLoading]);

	return (
		<>
			<form onSubmit={handleSubmit}>
				<div className="card restaurant-card mb-5">
					<div className="modal-header p-0 pb-3 mb-4 w-100">
						<h5 className="box-title modal-title">
							<i className="bx bx-user mr-1"></i> Tax Settings
						</h5>
					</div>
					<div className="row align-items-center">
						<div className="col-md-12 mt-3">
							<div className="row">
								<div className="form-group col-md-6 mb-md-4 mb-3">
									<label className="mb-0" htmlFor="restaurantName">
										Master Restaurant Address For Tax Deductions
									</label>
									<div className="w-100">
										<Select
											className="default-select"
											value={values.restaurant}
											options={childRestaurantOptions}
											searchable={true}
											placeholder="Select master address for tax"
											onChange={(val) => {
												let event = {
													target: { name: "restaurant", value: val },
												};
												handleChange(event);
											}}
										/>
									</div>
									<span className="text-danger d-block">
										{errors.restaurant && touched.restaurant
											? errors.restaurant
											: null}
									</span>
								</div>
								<div className="col-md-12 mt-4 btn-blocks text-right">
									<button
										type="submit"
										className="btn btn-primary glow-primary mr-4"
									>
										Save Changes
									</button>
									<Link
										className="btn btn-outline-primary"
										to={`${URL.restaurants}/${slug}`}
									>
										Cancel
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</>
	);
};

export default TaxSettings;
